import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const createScimToken = api(async function createScimToken({ clientId, note } = {}) {
    return await mutate(
        gql`
            mutation createScimToken($clientId: String, $note: String) {
                createScimToken(clientId: $clientId, note: $note) {
                    _id
                    prefix
                    token
                    createdAt
                }
            }
        `,
        { clientId, note },
        { returns: "createScimToken" }
    )
})
